import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Home.module.css";
import LoginPopup from "./LoginPopup";

const Home = () => {
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);

    const [currentUser, setCurrentUser] = useState(() => {
        const saved = localStorage.getItem("chitra_user");
        return saved ? JSON.parse(saved) : null;
    });

    const handleGetStarted = () => {
        if (currentUser) {
            navigate("/chat");
        } else {
            setShowLogin(true);
        }
    };

    const handleLoginSuccess = (userData) => {
        localStorage.setItem("chitra_user", JSON.stringify(userData));
        setCurrentUser(userData);
        setShowLogin(false);
        navigate("/chat");
    };

    return (
        <div className={classes.homeLayout}>
            {/* Top Minimalist Navbar */}
            <nav className={classes.navbar}>
                <div className={classes.logo}>
                    CHITRA <span className={classes.logoSubtitle}>Slidegen</span>
                </div>
                {currentUser ? (
                    <button onClick={() => navigate("/chat")} className={classes.navBtnSecondary}>
                        Go to Workspace ➔
                    </button>
                ) : (
                    <button onClick={() => setShowLogin(true)} className={classes.navBtnPrimary}>
                        Log In
                    </button>
                )}
            </nav>

            {/* Core Content Area */}
            <main className={classes.mainContent}>
                <div className={classes.heroCard}>
                    <div className={classes.badge}>Compositional Multi-Agent Architecture</div>
                    <h1 className={classes.heroTitle}>
                        Transform Ideas & Documents Into <span className={classes.gradientText}>Flawless Presentations</span>
                    </h1>
                    <p className={classes.heroSubtitle}>
                        Powered by CHITRA. An advanced system of specialized AI agents that collaboratively research, write, fact-check, and design executive-grade presentation slides in real-time.
                    </p>

                    <div className={classes.ctaGroup}>
                        <button onClick={handleGetStarted} className={classes.mainCtaBtn}>
                            Start Generating Now
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </button>
                    </div>

                    {/* Features Matrix Callout */}
                    <div className={classes.featureGrid}>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🔍</div>
                            <h3>Deep Web Research</h3>
                            <p>Parallel search execution pipelines powered by Serper and Perplexity infrastructure engines.</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🛡️</div>
                            <h3>Grounded Content</h3>
                            <p>Rigorous Verity fact-check agents eliminate hallucinations with strict source grounding constraints.</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🎨</div>
                            <h3>Tailwind Layout Streaming</h3>
                            <p>Real-time layouts designed by elite asset directors and streamed via atomic UI components over Server-Sent Events.</p>
                        </div>
                    </div>
                </div>
            </main>

            {showLogin && (
                <LoginPopup
                    onLoginSuccess={handleLoginSuccess}
                    onClose={() => setShowLogin(false)}
                />
            )}
        </div>
    );
};

export default Home;